<template>
  <div>

    <!-- 標題 bar -->
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">天地生肖走势</span>
        </div>
      </div>
    </div>

    <RadioButtons v-model="select" title="筛选球位" :buttons="filterData" />

    <div v-loading="isLoading" class="TianDiShengXiaoZouShi">
      <trend :x-list="xList" :y-list="yList" :data="showdata" :slice="slice" :area-color="areaColor" img-type="3" />
    </div>
  </div>
</template>

<script>
import RadioButtons from '@/components/web/common/RadioButtons'
import trend from '@/components/desktop/common/trend/trend'
import { getTrand } from '@/api/desktop/trend'

export default {
  name: 'TianDiShengXiaoZouShi',
  components: {
    trend,
    RadioButtons
  },
  data() {
    return {
      isLoading: false,
      data: [],
      filterData: [
        { name: '正码一', val: 0 },
        { name: '正码二', val: 1 },
        { name: '正码三', val: 2 },
        { name: '正码四', val: 3 },
        { name: '正码五', val: 4 },
        { name: '正码六', val: 5 },
        { name: '特码', val: 6 }
      ],
      areaColor: ['#29C0FF', '#FFC514'],
      xList: [],
      yList: [
        // 天肖
        'shengXiao_niou', // 牛
        'shengXiao_tu', // 兔
        'shengXiao_long', // 龙
        'shengXiao_ma', // 马
        'shengXiao_hou', // 猴
        'shengXiao_jhu', // 猪
        // 地肖
        'shengXiao_shu', // 鼠
        'shengXiao_hu', // 虎
        'shengXiao_she', // 蛇
        'shengXiao_yang', // 羊
        'shengXiao_ji', // 鸡
        'shengXiao_gou' // 狗
      ], // 天肖地肖分組對應
      select: 0,
      showdata: [],
      slice: [6]
    }
  },
  watch: {
    select() {
      this.pickNum(this.select)
    }
  },
  mounted() {
    this.getTrand(this.$route.params.lottery_code, { count: 30 })
  },
  methods: {
    async getTrand(code, query) {
      this.isLoading = true
      const [data, error] = await getTrand(code, query)
      this.isLoading = false
      if (error) {
        console.error(error)
        return
      }
      this.xList = data.map(el => el.period.length === 10 ? el.period.substr(el.period.length - 4, 4) : el.period.substr(el.period.length - 3, 3))
      this.data = data
      this.pickNum(0)
    },
    pickNum(val) {
      this.showdata = []
      this.data.forEach(per => {
        per.shengXiao.forEach((ball, ballIndex) => {
          if (ballIndex === val) {
            this.showdata.push(ball)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.TianDiShengXiaoZouShi {
  width: 100%;
  height: 600px;
  background-color: white;
}
</style>

